module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Green Unison Journal","short_name":"GU Journal","description":"Green Unison Journal — practical stories, recipes, growing tips, and botanical guides.","lang":"en","display":"standalone","icon":"src/images/favicon.png","start_url":"/","background_color":"#ffffde","theme_color":"#06602b","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"be967454471c420e68219790a0e411cc"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
